import { Helmet, HelmetProvider } from 'react-helmet-async';

import { useSessionSlots, useWorkspace } from '@treams/treams-hooks';

import AppAuthenticated from '../../../../../packages/@treams/treams-app/src/pages/authentication/AppAuthenticated';
import AppUnauthenticated from '../../../../../packages/@treams/treams-app/src/pages/authentication/AppUnauthenticated';
import Prelogin from '../../../../../packages/@treams/treams-app/src/pages/authentication/Prelogin';
import FullPageLoadingContainer from '../../pages/loading/FullPageLoadingContainer';

function AppRoot() {
	const { slots, loading } = useSessionSlots();
	const workspace = useWorkspace();

	if (workspace.id === 'try' || location.pathname == '/try') {
		window.location.replace('https://treams.com/nl/try-treams');
		return <></>;
	} else if (workspace.id === 'login') {
		return <Prelogin />;
	}

	if (loading && slots.length === 0) {
		return <FullPageLoadingContainer />;
	}

	return (
		<HelmetProvider>
			<Helmet titleTemplate="%s - Treams" />
			{slots.length > 0 ? <AppAuthenticated /> : <AppUnauthenticated />}
		</HelmetProvider>
	);
}

export default AppRoot;
